import React from 'react';
import { Block, VideoEmbed } from '@guryou/html-components';
const isYouTubeUrl = url => {
  if (!url) {
    return false;
  }
  return url.includes('youtube.com/watch') || url.includes('youtube.com/embed') || url.includes('youtu.be/');
};
const getYouTubeEmbedUrl = url => {
  // Match ?v=xxxx
  const watchMatch = url.match(/v=([^&]+)/);
  if (watchMatch) {
    return "https://www.youtube.com/embed/".concat(watchMatch[1]);
  }

  // Match youtu.be/xxxx
  const shortMatch = url.match(/youtu\.be\/([^?]+)/);
  if (shortMatch) {
    return "https://www.youtube.com/embed/".concat(shortMatch[1]);
  }

  // Already embed form
  if (url.includes('/embed/')) {
    return url;
  }
  return null;
};
const isVimeoUrl = url => {
  if (!url) {
    return false;
  }
  return url.includes('vimeo.com');
};
const getVimeoEmbedUrl = url => {
  const match = url.match(/vimeo\.com\/(\d+)/);
  return match ? "https://player.vimeo.com/video/".concat(match[1]) : null;
};
const HtmlVideoPlayer = _ref => {
  let {
    src
  } = _ref;
  if (isYouTubeUrl(src)) {
    const embedUrl = getYouTubeEmbedUrl(src);
    return /*#__PURE__*/React.createElement(VideoEmbed, {
      embedUrl: embedUrl,
      width: "586px",
      height: "415"
    });
  }
  if (isVimeoUrl(src)) {
    const embedUrl = getVimeoEmbedUrl(src);
    return /*#__PURE__*/React.createElement(VideoEmbed, {
      embedUrl: embedUrl,
      width: "586px",
      height: "415"
    });
  }
  return /*#__PURE__*/React.createElement(Block, {
    textAlign: "center"
  }, /*#__PURE__*/React.createElement("video", {
    autoPlay: true,
    controls: true,
    style: {
      width: '100%',
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement("source", {
    src: src,
    type: "video/mp4"
  }), "Your browser does not support the video tag."));
};
export { HtmlVideoPlayer };